import { defaultColor } from "../constants/DefaultColor";

export const generateSearchRecords = (tournament, batch) => {
  const db = window.firebase.firestore();

  let record = {
    name: tournament.name || "",
    date: tournament.date || "",
    bgURL: tournament.bgURL || "",
    logoURL: tournament.logoURL || "",
    color: tournament.color || defaultColor,
  };
  let keywords = [];
  for (let x = 0; x < (tournament.name || "").length; x++) {
    let name = tournament.name.slice(x);
    for (let y = 0; y < name.length; y++) {
      let namePart = name.slice(0, y + 1);
      if (namePart.length > 0) {
        keywords.push(namePart.toLowerCase());
      }
    }
  }
  record["keywords"] = keywords;
  let newDoc = db.collection("tournamentSearch").doc(tournament.id);
  batch.set(newDoc, record);

  return batch;
};
